import { useQuery } from "@tanstack/react-query";
import { create } from "zustand";
import { AdgemOffer, RevuOffer } from "@/types/offer";
import { useMemo } from "react";
import { getPlatform } from "@/utils/platform";
import OfferServices from "@/services/offerServices";
import { Offer } from "@/types/offer";

type OffersState = {
  supportPortalUrl: string;
  offers: Offer[];
  setOffers: (_offers: Offer[]) => void;
  setSupportPortalUrl: (_url: string) => void;
};

const useOffersStore = create<OffersState>((set) => ({
  offers: [],
  supportPortalUrl: "",
  setOffers: (offers) => set({ offers }),
  setSupportPortalUrl: (supportPortalUrl) => set({ supportPortalUrl }),
}));

export const useOffers = () => {
  const { setOffers, setSupportPortalUrl } = useOffersStore();
  const offers = useOffersStore((state) => state.offers);
  const supportPortalUrl = useOffersStore(
    (state) => state.supportPortalUrl
  );

  const params = useMemo(() => ({
    platform: getPlatform(),
    sort: "epc.desc",
    country_codes: "US",
  }), []);

  const query = useQuery({
    queryKey: ["offers", params],
    queryFn: async () => {
      try {
        const response = await OfferServices.getOffers(params);
        if(response.offers?.length) {
          setOffers(response.offers);
        }
        setSupportPortalUrl(response.supportPortalUrl);
        return response;
      } catch (error) {
        console.error("Error fetching offers:", error);
        setOffers([]);
        setSupportPortalUrl("");
        throw error;
      }
    },

    refetchInterval: 5 * 60 * 1000,
    refetchIntervalInBackground: true,
    staleTime: 5 * 60 * 1000,
  });

  return {
    offers,
    supportPortalUrl,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error,
    refetch: query.refetch,
    isRefetching: query.isRefetching,
    data: query.data,
  };
};
